import { AuthConfig } from 'angular-oauth2-oidc';
import { environment } from "@env/environment";
import { RootRoute } from "@v1/core/app/enums/root.route";
import { AuthRoute } from "@v1/features/auth/enums/auth.route";

export const authCodeFlowConfig: AuthConfig = {
  issuer: environment.API_AUTH_BASE,
  loginUrl: `${environment.API_AUTH_BASE}/op/authorize`,
  logoutUrl: `${environment.API_AUTH_BASE}/op/logout`,
  tokenEndpoint: `${environment.API_AUTH_BASE}/op/token`,
  userinfoEndpoint: `${environment.API_AUTH_BASE}/op/userinfo`,

  redirectUri: window.location.origin + `/${environment.VERSION_ENABLE}/${RootRoute.auth}/${AuthRoute.callback}`,
  clientId: environment.clientId,
  responseType: 'code',
  scope: 'openid profile email enterprise offline_access',


  useSilentRefresh: false,
  timeoutFactor: 0.75,

  clockSkewInSec: 60,
  decreaseExpirationBySec: 0,

  requireHttps: environment.production,
  dummyClientSecret: '',
  showDebugInformation: !environment.production,

};
